

// built-in theme
import 'echarts/theme/dark'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


const list = () => ['成交价格', '成交量', '户型分布']

export default {
  data () {
      return {
        list2: list(),
        transitionName: 'slide-left',
        demo2: '成交价格',
        index: 0
      }
  },
  // dynamically set transition based on route change
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  mounted() {
    console.log("mounted");
  },
  created() {
      console.debug(">>> home body state jw:%o",this.$store.state.jw)
      console.debug(">>> home body after state type:%s",this.$store.state.jw.type)
      console.debug(">>> detail head state state:%o",this.$store.state)
      console.log("created currentRoute:%o", this.$root.currentRoute);
  },
  methods: {
    submit: function(){
      console.log("submit");
    },
    goHome: function(){
      console.log("goHome")
      this.$router.push({ path: '/',query: { type: this.$store.state.jw.type }})
    },
    handler: function(item){
      console.log("handler click ")
      console.log("list:%o", this.list2)

      switch(item)
      {
        case this.list2[1]:
          console.log(item)
          this.$router.push({ path: '/detail/qty' })
          break;
        case this.list2[2]:
          console.log(item)
          this.$router.push({ path: '/detail/type' })
          break;
        default:
          console.log(item)
          this.$router.push({ path: '/detail/' })
      }
      // this.$router.push({ path: '/' })


    }
  },
  components: {
    //MainLayout
    XHeader,
    Tab,
    TabItem,
    Sticky,
    Swiper,
    SwiperItem
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailHead.vue